import React, { useEffect, useState } from 'react';
import { Dialog, Form, Input, Select, Textarea } from 'tdesign-react';
import { addRole, updateRole } from '@/services/kafkaPermissionsService';
import { toTsOptions } from '@/utils/common';
import useDisableButton from '@/components/DisableWrapper/useDisableButton';

const { FormItem } = Form;

const options = [{ label: 'SCRAM', value: 'SCRAM' }];

export default function Modal({ handleClose, clusterName, visible, update, ...others }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const confirmBtn = useDisableButton({ loading: submitting, content: '确定' });
  const isUpdate = !!update;

  useEffect(() => {
    if (visible) {
      form.reset();
      // 修改
      if (isUpdate) {
        form.setFieldsValue(update);
      }
    }
  }, [visible, form, isUpdate, update]);

  const handleSubmit = async ({ validateResult, fields }) => {
    const request = isUpdate ? updateRole : addRole;
    if (validateResult === true) {
      setSubmitting(true);
      const type = fields.type || update.type;
      try {
        await request({ clusterName, type, ...fields });

        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  const doClose = () => handleClose();

  return (
    <Dialog
      header={isUpdate ? '修改密码' : '创建KafkaUser'}
      onCancel={doClose}
      onConfirm={() => form.submit()}
      confirmBtn={confirmBtn}
      onCloseBtnClick={doClose}
      onEscKeydown={doClose}
      visible={visible}
      width={550}
      {...others}
    >
      <Form onSubmit={handleSubmit} form={form} resetType='initial' style={{ width: '80%' }}>
        <FormItem name='kafkaUser' label='KafkaUser' rules={[{ required: true }]}>
          <Input disabled={isUpdate} placeholder='KafkaUser' />
        </FormItem>
        {!isUpdate && (
          <FormItem name='type' label='认证方式' rules={[{ required: true }]}>
            <Select placeholder='请选择' options={toTsOptions(options)} clearable />
          </FormItem>
        )}

        <FormItem name='password' label={isUpdate ? '新密码' : '密码'} rules={[{ required: true }]}>
          <Input type='password' placeholder='请输入' />
        </FormItem>

        {!isUpdate && (
          <FormItem name='note' label='备注'>
            <Textarea placeholder='请输入' />
          </FormItem>
        )}
      </Form>
    </Dialog>
  );
}
